import React from "react";
import StatusIndicator from "./status";
import { Button, CopyValue } from "../..";
import { MdOutlineDragIndicator } from "react-icons/md";
import { FiArrowRight } from "react-icons/fi";
import { getReceiptReimbursementEligibility } from "../../../Utils/expenseReimbursement";

function ApprovalStatus({ draggable, showDragHint = false, status, id, categoryId, description, amount, date, merchant, attachments, violations, onAddToReimbursement }) {
	const { canAddToReimbursement, canShowAction, disabledReason } = getReceiptReimbursementEligibility({ status, categoryId, description, amount, date, merchant, attachments, violations });
	const helperText = showDragHint && canAddToReimbursement ? "Drag to reimbursement panel" : canShowAction && !canAddToReimbursement ? disabledReason : "";
	return (
		<div className={`p-2 bg-whitish border-t ${draggable ? "cursor-move" : ""}`}>
			<div className="flex items-center justify-between gap-2">
				<div className="flex items-center gap-2 min-w-0">
					{draggable && <MdOutlineDragIndicator className="shrink-0" />}
					<CopyValue className="text-xxs truncate">RPT-{id}</CopyValue>
				</div>
				<div className="flex items-center gap-2 shrink-0">
					<StatusIndicator status={status} />
					{onAddToReimbursement && canShowAction ? (
						<Button onClick={onAddToReimbursement} disabled={!canAddToReimbursement} variant="primary" className="btn-xs gap-1">
							Move to Reimbursement <FiArrowRight />
						</Button>
					) : null}
				</div>
			</div>
			{helperText ? <div className="mt-1 text-xxs text-secondary min-w-0">{helperText}</div> : null}
		</div>
	);
}

export default ApprovalStatus;
